<template>
  <div class="activityShow">
    <div class="bgImg">
      <img src="@/assets/newDp/indexMnger/glsy-top-bg3.png" alt="" />
    </div>
    <div class="content">
      <div class="news-list" v-if="activityShow && activityShow.length != 0">
        <div
          class="news-template"
          v-for="news in activityShow"
          :key="news.id"
          @click="goDetail(news.id)"
        >
          <div class="news-left">
            <img
              :src="news.imgUrl"
              alt
              v-if="news.imgUrl == null ? false : true"
            />
          </div>
          <div class="news-right">
            <p>{{ news.headline }}</p>
            <p>
              <!-- <span style="margin-right: 0.5rem">浏览:{{ news.sees }}</span> -->
              <!-- <span>点赞:{{news.praise}}</span> -->
              <span style="margin-right: 0.3rem; float: right">{{
                news.createtime | times
              }}</span>
            </p>
          </div>
        </div>
      </div>
      <div v-else><noneBox /></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activityShow: [],
      c2userid: '',
      c2token: '',
      token: ''
    }
  },
  created() {
    this.c2userid = sessionStorage.getItem('c2userid')
    this.c2token = sessionStorage.getItem("c2token")
    this.token = sessionStorage.getItem("token")
  },
  mounted() {
    this.axios
      .post('/api/VolunteerActivity/ActivityList', {
        c1name: this.token ? this.token : this.c2token,
        c2userid: parseInt(this.c2userid),
      })
      .then((res) => {
        console.log('res: ', res)
        if (typeof res.data.msg === 'string') {
          this.activityShow = []
        } else {
          this.activityShow = res.data.msg
          this.activityShow && this.activityShow.forEach((item, index) => {
            item.imgUrl = item.memo.split('src="')[1]
              ? item.memo.split('src="')[1].split('"')[0]
              : null
          })
        }
      })
  },
  methods: {
    goDetail(id) {
      this.$router.push({
        path: '/activityShowDetail',
        query: { title: '志愿活动风采详情', id },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.activityShow {
  display: flex;
  justify-content: center;
  .news-list {
    .news-template {
      width: 94%;
      margin: 0 auto;
      display: flex;
      margin-bottom: 0.2rem;
      background: #fff;
      padding: 0.2rem 0;
      //   align-items: center;
      .news-right {
        width: 100%;
        margin-left: 0.2rem;
        p:nth-child(1) {
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-all;
          display: -webkit-box;
          margin-bottom: 0.3rem;
          line-height: 1.8;
          //   border-bottom: 0.01rem solid #E6E6E6;
        }
        p:nth-child(2) {
          border-top: 0.01rem solid #e6e6e6;
          padding-top: 0.2rem;
          color: #999999;
          font-size: 0.26rem;
        }
      }
      .news-left {
        img {
          width: 2.4rem;
          height: 2rem;
        }
      }
    }
    margin-top: 0.3rem;
    font-size: 0.3rem;
  }
  padding-top: 1rem;
}
.bgImg {
  img {
    width: 100%;
    height: 8.13rem;
  }
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  margin-top: 0.91rem;
}
.content {
  background: #fff;
  border-radius: 0.15rem;
  margin-top: 2.71rem;
  width: 7.1rem;
  height: 100%;
  padding: 0.2rem 0.2rem;
}
</style>
